import { useState } from "react";
import { wrapperClassName } from "../../constants";
import classNames from "classnames";
import { mapComponentFromType } from "./utils/typeMapping";
import { LOADMORE_AD_TYPE } from "../../../Ad/constants";

export const ContentWrapper = function (props) {
    const {
        contentData,
        contentLayout,
        isList,
        contentIndex,
        path,
        hideAuthorInfo,
        cardClickHandler,
    } = props;

    // For asynchronous removal of content wrappers from the grid, e.g, for native ads with an empty ad call empty
    const [nullRender, setNullRender] = useState(false);
    if (nullRender) {
        return null;
    }

    //For certain data types the content component will be determined by type and flags rather than by the layout. This defaults to the content component provided in the props.
    const ContentComponent = mapComponentFromType(props);
    const { wrapperClasses, contentClasses } = contentLayout;

    const wrapperClassNames = classNames(
        {
            "full-width-grid-item": contentData.type === LOADMORE_AD_TYPE,
        },
        wrapperClassName,
        wrapperClasses,
        contentData.trackingClass
    );

    const ContentJsx = (
        //ContentComponent a generic variable name, the actual component rendered here will be whatever was passed in as a prop, or for certain contentData types the component returned by mapComponentFromType above.
        <ContentComponent
            {...{
                ...contentData,
                className: contentClasses,
                setNullRender,
                contentIndex,
                path,
                hideAuthorInfo,
                cardClickHandler,
            }}
        />
    );

    const featurePosition = isNaN(contentIndex) ? null : contentIndex + 1;

    return isList ? (
        <li
            data-feature-position={featurePosition}
            className={wrapperClassNames}
            data-testid="content-wrapper-li"
        >
            {ContentJsx}
        </li>
    ) : (
        <div
            data-feature-position={featurePosition}
            className={wrapperClassNames}
            data-testid="content-wrapper-div"
        >
            {ContentJsx}
        </div>
    );
};

export default ContentWrapper;
